enum ScreeningModalFragmentEnum {
    ScreeningActivation = 'ScreeningActivation',
    ScreeningActivationSuccess = 'ScreeningActivationSuccess',
    ScreeningCandidate = 'ScreeningCandidate',
    ScreeningError = 'ScreeningError',
}

export default ScreeningModalFragmentEnum;
